import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import { Container, Row, Col, Button } from 'reactstrap';
import { withLocale } from '@dietlabs/components';
import withOnCriticalError from 'view/ErrorBoundary/withOnCriticalError';
import { PATHS } from 'config/paths';
import ShoppingCartConfirmPaymentOnlineContainer from 'view/ShoppingCart/Confirm/Payment/ShoppingCartConfirmPaymentOnlineContainer';
import ShoppingCartConfirmPaymentCodContainer from 'view/ShoppingCart/Confirm/Payment/ShoppingCartConfirmPaymentCodContainer';
import Payment from 'view/Payment/Payment';
import ShoppingCartOrderProductsSummaryComponent from 'components/ShoppingCart/Order/ShoppingCartOrderProductsSummaryComponent';
import ShoppingCartOrderDeliverySummaryComponent from 'components/ShoppingCart/Order/ShoppingCartOrderDeliverySummaryComponent';
import ShoppingCartConfirmPlaceholder from 'components/ShoppingCart/Confirm/ShoppingCartConfirmPlaceholder';
import Layout from 'Layout/Layout';

export class ShoppingCartConfirmComponent extends React.Component {
    state = {
        initialized: false,
    };

    async componentDidMount() {
        try {
            if (!this.props.payment.isInit() && !this.props.payment.isCod()) {
                const clonedPayment = await this.props.clonePayment(
                    this.props.payment.token
                );
                const redirectTo =
                    PATHS.CART.CONFIRM.split(':')[0] + clonedPayment.token;

                this.setState({
                    initialized: true,
                    redirectTo,
                });
            } else {
                this.setState({ initialized: true });
            }
        } catch (error) {
            this.props.onCriticalError(error);
        }
    }

    render() {
        if (this.state.initialized) {
            if (this.state.redirectTo) {
                if (this.state.redirectTo !== global.location.pathname) {
                    return <Redirect to={this.state.redirectTo} />;
                }
                return '';
            }

            const { payment } = this.props;

            const backToCart = payment.isInit() ? (
                <section className="text-center">
                    <Container>
                        <Button
                            data-test="back-to-cart"
                            tag={Link}
                            to={PATHS.CART.INDEX}
                            color="link"
                        >
                            {this.props.t('cart/back-to-cart')}
                        </Button>
                    </Container>
                </section>
            ) : (
                ''
            );

            return (
                <Layout page="cart">
                    <header>
                        <h1 className="text-center d-none d-md-block">
                            {this.props.t('cart/order-confirm')}
                        </h1>
                    </header>

                    {payment.requiresDelivery() ? (
                        <Container className="mb-5">
                            <Row>
                                <Col md="5">
                                    <ShoppingCartOrderDeliverySummaryComponent
                                        delivery={payment.delivery}
                                        isAbleToProcess={payment.isInit()}
                                    />
                                </Col>
                                <Col md="7">
                                    <ShoppingCartOrderProductsSummaryComponent
                                        products={payment.products}
                                        productsPrice={payment.productsPrice}
                                        deliveryOptionPrice={
                                            payment.deliveryOptionPrice
                                        }
                                        totalPrice={payment.totalPrice}
                                    />
                                </Col>
                            </Row>
                        </Container>
                    ) : (
                        <Container className="mb-5">
                            <ShoppingCartOrderProductsSummaryComponent
                                products={payment.products}
                                productsPrice={payment.productsPrice}
                                deliveryOptionPrice={
                                    payment.deliveryOptionPrice
                                }
                                totalPrice={payment.totalPrice}
                            />
                        </Container>
                    )}

                    {payment.isCod() ? (
                        <ShoppingCartConfirmPaymentCodContainer
                            isAbleToProcess={payment.isInit()}
                            token={payment.token}
                        />
                    ) : (
                        <ShoppingCartConfirmPaymentOnlineContainer
                            token={payment.token}
                        />
                    )}

                    <section className="pt-4 pb-5">{backToCart}</section>
                </Layout>
            );
        }
        return <ShoppingCartConfirmPlaceholder />;
    }
}

ShoppingCartConfirmComponent.propTypes = {
    payment: PropTypes.instanceOf(Payment).isRequired,
    clonePayment: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    onCriticalError: PropTypes.func.isRequired,
};

export default withOnCriticalError(withLocale(ShoppingCartConfirmComponent));
